import {
  Center,
  Flex,
  Space,
  Tag,
  Button,
  Text,
  getTheme,
} from '@conexasaude/conexa-hero'
import { Illustration } from '@conexasaude/iconography/illustrations'
import { FeedbackErrorProps } from './FeedbackError.types'
import { FunctionComponent } from 'react'

export const FeedbackError: FunctionComponent<FeedbackErrorProps> = ({
  eventId,
}) => {
  const theme = getTheme()

  function redirectToHome() {
    window.location.href = `${window.location.origin}/`
  }

  return (
    <Center h="100vh">
      <Flex direction="column" align="center" w={500} maw="90%">
        <Illustration name="woman-search-with-error" />
        <Flex direction="column" gap={theme.spacing.xxs}>
          <Text variant="headingMedium" textAlign="center">
            Sentimos muito, algo não saiu como o esperado.
          </Text>

          <Text variant="paragraphLarge" textAlign="center">
            Algo deu errado no carregamento da página. Você pode retornar à tela
            inicial e tentar novamente.
          </Text>
        </Flex>

        <Space my="lg">
          <Tag variant="error">{eventId}</Tag>
        </Space>

        <Button onClick={redirectToHome}>Voltar para o início</Button>
      </Flex>
    </Center>
  )
}
